import React, { Component } from 'react';
import { Icon } from 'antd';
import util from '@util/index';
import './index.less';
/**
 * 暂无数据
 */
const color = ['#1890ff', '#52c41a'];
export default class Pmgressbar extends Component {
  render() {
    const { data } = this.props;
    let dePer = 1;
    let ind = 1;
    data.map((item, index) => {
      if (item.per < dePer) {
        dePer = item.per;
        ind = index;
      }
      return item;
    });
    return (
      <div className="bar1">
        {data.map((item, index) => {
          const per = `${((item.per || 0) * 100).toFixed(2)}%`;
          return (
            <div
              style={{
                width: parseFloat(per) > 100 ? '100%' : per,
                background: item.color || color[index],
                zIndex: index === ind && '10',
              }}
              className="bar-item"
              key={item.type}
            >
              {item.location === 'top' ? (
                <div className="bar-tip bar-tip-top">
                  <div className="value-wrapper">
                    <div>{item.type}</div>
                    <div className="value">{util.numberFormat(item.value || 0)}</div>
                    {per}
                  </div>
                  <Icon type="caret-down" style={{ color: '#d5d5d5' }} />
                </div>
              ) : (
                <div className="bar-tip bar-tip-bot">
                  <Icon type="caret-up" style={{ color: '#d5d5d5' }} />
                  <div className="value-wrapper">
                    <div>{item.type}</div>
                    <div className="value">{util.numberFormat(item.value || 0)}</div>
                    {per}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/comm/Pmgressbar/Index.js